import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultComponent } from './components/results/result/result.component';
import { VerificationRedirectionService } from './guards/verification-redirection.service';
import { VerificationComponent } from './components/verification/verification.component';

const routes: Routes = [
  {
    path: '', data: { breadcrumb: 'breadcrumb.verification_space' },
    children: [
      {
        path: 'process',
        component: VerificationComponent,
        data: { breadcrumb: 'breadcrumb.verify_signature' },
        children: [
          {
            path: 'resultat',
            component: ResultComponent,
            data: { breadcrumb: 'breadcrumb.result_signature' },
            canActivate: [VerificationRedirectionService],
            outlet: 'verification',
          }
        ]
      }
    ]
  }
];

@NgModule({
  providers: [
    VerificationRedirectionService,
  ],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationRoutingModule {
}
